import { ReactiveController, ReactiveControllerHost } from 'lit';

export class TimeoutController implements ReactiveController {
  host: ReactiveControllerHost;

  checkIntervalMs: number;

  checkFn: () => Promise<boolean>;

  checkIsTrueFn: Function;

  checkIsFalseFn?: Function;

  private _interval?: number;

  constructor(
    host: ReactiveControllerHost,
    checkFn: () => Promise<boolean>,
    checkIsTrueFn: Function,
    checkIsFalseFn: Function,
    checkIntervalMs = 1000,
  ) {
    (this.host = host).addController(this);
    this.checkFn = checkFn;
    this.checkIsTrueFn = checkIsTrueFn;
    this.checkIsFalseFn = checkIsFalseFn;
    this.checkIntervalMs = checkIntervalMs;
  }

  setInterval() {
    this._interval = window.setInterval(async () => {
      const check = await this.checkFn();
      if (check) {
        this.checkIsTrueFn();
        this.clearInterval();
      } else if (this.checkIsFalseFn) {
        this.checkIsFalseFn();
      }
    }, this.checkIntervalMs);
  }

  clearInterval() {
    clearInterval(this._interval);
    this._interval = undefined;
  }

  hostDisconnected() {
    this.clearInterval();
  }
}
